import Moment from 'moment'
import { listOfDays } from '../../../helpers'

export const calcPaymentOptions = issCase =>
  issCase.gov_record['ListOfCareHours']['CareHours']
    .reduce((options, h) => {
      if (options.indexOf(h['PaymentType']) > -1) return options
      options.unshift(h['PaymentType'])
      return options
    }, [])
    .map(e => ({ value: e }))

export const calcServiceProvisionOptions = issCase => {
  const hasNonFaceToFaceTime = issCase.gov_record['TotalISNonFaceToFaceHrsAllowed']
    .split(':')
    .filter(t => parseInt(t, 10) > 0)

  return hasNonFaceToFaceTime.length > 0
    ? [{ value: 'Face-to-Face' }, { value: 'Non Face-to-Face' }]
    : [{ value: 'Face-to-Face' }]
}

export const findEnrolments = issCase => issCase.gov_record['ListOfISEnrolments']['ISEnrolment']

export const findEnrolmentIds = issCase => findEnrolments(issCase).map(e => e['EnrolmentId'])

export const findEnrolmentsInDay = (issCase, paymentType, { name }) => {
  const childIDS = daysWithPaymentType(issCase, paymentType)
    .filter(({ DayOfCare }) => String(DayOfCare).toLowerCase() === name.toLowerCase())
    .map(({ ChildId }) => ChildId)

  if (childIDS.length === 0) {
    return childIDS
  }

  return findEnrolments(issCase).filter(({ ChildId }) => childIDS.includes(ChildId))
}

export const listOfCareHours = ({ gov_record = {} }, paymentType) => {
  let output = {}
  if (gov_record.ListOfCareHours && gov_record.ListOfCareHours.CareHours) {
    gov_record.ListOfCareHours.CareHours.forEach(({ DayOfCare, DayHours, PaymentType }) => {
      if (PaymentType === paymentType) {
        output[DayOfCare] = parseHours(DayHours)
      }
    })
  }

  return output
}

export const dayInClaim = (record, paymentType, { name }) =>
  daysWithPaymentType(record, paymentType).filter(
    ({ DayOfCare }) => String(DayOfCare).toLowerCase() === name.toLowerCase()
  )[0]

export const daysWithPaymentType = (record, paymentType) =>
  listOfDays(record).filter(value => value.PaymentType === paymentType)

export const parseHours = val => Moment.duration(val).as('hours')

export const totalTimeForDay = values =>
  values
    .map(({ hours, minutes }) =>
      Moment.duration(Number(hours), 'hours')
        .add(Number(minutes), 'minutes')
        .as('hours')
    )
    .reduce((a, b) => a + b, 0)

export const timeFormatted = hours =>
  // because you can't directly format durations
  // and we need to display hours over 24
  [
    Math.floor(hours),
    Moment()
      .startOf('day')
      .add(hours % 1, 'hours')
      .format(':mm'),
    ' hours',
  ].join('')



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/helpers.js